import { render, staticRenderFns } from "./plogskill.vue?vue&type=template&id=6ba9a556&scoped=true&"
import script from "./plogskill.vue?vue&type=script&lang=js&"
export * from "./plogskill.vue?vue&type=script&lang=js&"
import style0 from "./plogskill.vue?vue&type=style&index=0&id=6ba9a556&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba9a556",
  null
  
)

export default component.exports